module.exports = __webpack_public_path__ + "img/12.bb5f91d0.jpg";